import gql from 'graphql-tag';

const GET_SPONSORS_DETAILS = gql`
  query sponsor($id: String){
    sponsor(id: $id) {
      id
      image
      name
      booth
      type
      site
      events{
        id
        title
        day
        start
        end
        room
        url
        type{
          name
          color
        }
      }
    }
  }
`
;

export default GET_SPONSORS_DETAILS;



/** WEBPACK FOOTER **
 ** ./src/graphql/GET_SPONSORS_DETAILS.js
 **/